<template>
  <v-row density="compact">
    <p>
      Matches stocks trading a chosen percentage above or below a moving average. Use "above" to
      find extended/overbought names (or momentum confirmation) and "below" to find pullbacks toward
      or under a longer-term average.
    </p>
    <v-col cols="12" sm="6">
      <v-select
        :model-value="rule.config.above_below"
        :items="above_below"
        item-title="title"
        item-value="value"
        label="Above or Below the MA"
        density="compact"
        hide-details
        variant="outlined"
        @update:model-value="updateConfig('above_below', $event)"
      />
    </v-col>
    <v-col cols="12" sm="6">
      <v-select
        :model-value="rule.config.ma_days"
        :items="ma_days"
        label="Moving Average Days"
        density="compact"
        hide-details
        variant="outlined"
        @update:model-value="updateConfig('ma_days', $event)"
      />
    </v-col>
    <v-col cols="12" sm="12">
      <v-text-field
        :model-value="rule.config.percent"
        density="compact"
        hide-details
        variant="outlined"
        label="Minimum distance from MA (%)"
        @update:model-value="updateConfig('percent', $event)"
      />
    </v-col>
  </v-row>
</template>

<script>
export default {
  components: {},
  props: {
    rule: { type: Object, required: true }
  },
  emits: ['update:rule'],
  data() {
    return {
      ma_days: [5, 10, 20, 50, 100, 150, 200],
      above_below: [
        { title: 'At least X% above the MA (extended)', value: 'above' },
        { title: 'At least X% below the MA (pullback)', value: 'below' }
      ],
      defaultTa: {
        enabled: true,
        rule_type: 'ma_extension',
        ma_days: 50,
        above_below: 'above',
        percent: 10,
        long_short: 'long'
      }
    }
  },

  mounted() {
    if (!this.rule.config || !this.rule.config.rule_type || this.rule.trend != 'ma_extension') {
      this.$emit('update:rule', { ...this.rule, config: Object.assign({}, this.defaultTa) })
    }
  },

  methods: {
    updateConfig(key, value) {
      this.$emit('update:rule', { ...this.rule, config: { ...this.rule.config, [key]: value } })
    }
  }
}
</script>
